import { generateAsyncSelectors } from "state/hor/addFetcherActionsToBuilder";
import { CountryByIpState } from "state/tree/countryByIp";

export default generateAsyncSelectors<CountryByIpState>();
